(function(){
  const tiers = [
    { amount: 50,   discount: 5   },
    { amount: 250,  discount: 10  },
    { amount: 500, discount: 15  }
  ];
  const maxAmount   = tiers[tiers.length - 1].amount;
  const maxDiscount = tiers[tiers.length - 1].discount;
  let lastSubtotal  = null;

// 1) Read the "Subtotal" from the correct element
function getCartSubtotal() {
  // Try to directly select the subtotal element by class
  const valueEl = document.querySelector('.totals__value__subtotal');
  if (valueEl) {
    // parse “£123.45” → 123.45
    const num = parseFloat(valueEl.textContent.replace(/[^0-9.]/g, ''));
    return isNaN(num) ? 0 : num;
  }
  // fallback for legacy layouts (optional)
  const blocks = document.querySelectorAll('div.totals');
  for (const block of blocks) {
    const heading = block.querySelector('h2.totals__total');
    if (heading && heading.textContent.trim().toLowerCase() === 'subtotal') {
      const valEl = block.querySelector('p.totals__total-value');
      if (valEl) {
        const num = parseFloat(valEl.textContent.replace(/[^0-9.]/g, ''));
        return isNaN(num) ? 0 : num;
      }
    }
  }
  return 0;
}

  // 2) Inject the three price markers (once)
  function renderMarkers(wrapper) {
    if (wrapper.querySelectorAll('.marker').length) return;
    tiers.forEach(t => {
      const pct = (t.amount / maxAmount) * 100;
      const m = document.createElement('div');
      m.className = 'marker';
      m.style.left = pct + '%';

      const lbl = document.createElement('div');
      lbl.className = 'marker-label';
      lbl.textContent = `£${t.amount}`;

      m.appendChild(lbl);
      wrapper.appendChild(m);
    });
  }

  // 3) Build the footer message
  function buildMessage(subtotal) {
    let prev = 0;
    tiers.forEach(t => { if (subtotal >= t.amount) prev = t.discount; });
    const next = tiers.find(t => subtotal < t.amount);
    if (!next) {
      return `🎉 You’ve unlocked the maximum discount of ${maxDiscount}%!`;
    }
    const needed = (next.amount - subtotal).toFixed(2);
    return prev === 0
      ? `Spend £${needed} more to get ${next.discount}% off.`
      : `${prev}% off unlocked! Spend £${needed} more to reach ${next.discount}% off.`;
  }

  // 4) Update fill & footer
  function updateBar() {
    const subtotal = getCartSubtotal();
    if (subtotal === lastSubtotal) return;
    lastSubtotal = subtotal;

    const fillEl = document.querySelector('.progress-fill');
    const msgEl  = document.querySelector('.discount-message');
    if (!fillEl || !msgEl) return;

    const pct = Math.min((subtotal / maxAmount) * 100, 100);
    fillEl.style.width = pct + '%';
    msgEl.textContent  = buildMessage(subtotal);
  }

  // 5) Initialize & live‐update hooks
  function init() {
    const wrapper = document.querySelector('.progress-wrapper');
    const track   = wrapper && wrapper.querySelector('.progress-track');
    if (!wrapper || !track) return;

    renderMarkers(wrapper);
    updateBar();

    document.body.addEventListener('cart:updated', updateBar);
    document.body.addEventListener('cart:refresh', updateBar);
    if (window.jQuery) jQuery(document).ajaxComplete(updateBar);
    setInterval(updateBar, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();